import React from 'react';
import { motion } from 'framer-motion';
export const WhyFla = () => {
  return <section id="why-fla" className="bg-[#0A0A0A] py-32 relative border-y border-gold/10" data-id="element-102">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-103">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="font-serif text-2xl md:text-3xl text-gold tracking-[0.2em] uppercase mb-12 font-light leading-relaxed" data-id="element-104">
          No es solo un turno.
          <br data-id="element-105" />
          Es una experiencia.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="font-sans font-light text-offwhite/70 text-sm md:text-base leading-relaxed" data-id="element-106">
          Diagnóstico personalizado antes de cada servicio. Técnicas
          artesanales, sin fórmulas genéricas. Resultados que respetan la salud
          de tu cabello.
        </motion.p>
      </div>
    </section>;
};